module.exports = __webpack_public_path__ + "img/ATB-logo.bbbd821b.png";